import { queryOptions } from '@tanstack/react-query'
import queryString from 'query-string'

import { apiClient, MEAL_PLANNER_API_URL } from '.'
import { User, UserProfile } from './types'

export async function fetchUsers(dbContext: string) {
  return apiClient
    .get<User[]>('/user', {
      headers: {
        'X-IMPERSONATE-USER-DB-CONTEXT': dbContext,
        'X-IMPERSONATE-USER-ID': '1',
      },
    })
    .then((res) => res.data.filter((u) => !!u.email))
}

export async function fetchUser(idUser: string, dbContext?: string) {
  const headers = dbContext
    ? { 'X-IMPERSONATE-USER-DB-CONTEXT': dbContext, 'X-IMPERSONATE-USER-ID': '1' }
    : {}
  return apiClient
    .get<UserProfile>(`/user/${idUser}`, {
      headers,
    })
    .then((res) => res.data)
}

export const usersQuery = (dbContext?: string) =>
  queryOptions({
    queryKey: ['users', dbContext],
    queryFn: () => fetchUsers(dbContext!),
    enabled: !!dbContext,
  })

export const userQuery = (dbContext: string, idUser: string) =>
  queryOptions({
    queryKey: ['user', dbContext, idUser],
    queryFn: () => fetchUser(idUser, dbContext),
    enabled: !!idUser,
  })

export async function resetPassword(dbContext: string, idUser: number, password: string) {
  return apiClient
    .put(`/user/${idUser}/password`, password, {
      headers: {
        'Content-Type': 'application/json',
        'X-IMPERSONATE-USER-DB-CONTEXT': dbContext,
        'X-IMPERSONATE-USER-ID': '1',
      },
    })
    .then((res) => res.data)
}

export async function createUser(user: User & { dbContext: string }, temporaryPassword: boolean) {
  return apiClient
    .post<User>('/user', user, {
      headers: {
        'X-IMPERSONATE-USER-DB-CONTEXT': user.dbContext,
        'X-IMPERSONATE-USER-ID': '1',
      },
      params: {
        temporaryPassword,
      },
      paramsSerializer: (params) => {
        return queryString.stringify(params)
      },
    })
    .then((res) => res.data)
}

export async function deleteUser(dbContext: string, idUser: number) {
  return apiClient
    .delete<User[]>(`/user/${idUser}`, {
      headers: {
        'X-IMPERSONATE-USER-DB-CONTEXT': dbContext,
        'X-IMPERSONATE-USER-ID': '1',
      },
    })
    .then((res) => res.data)
}

export async function fetchDBContexts() {
  return apiClient
    .get<Record<string, string>>('/administration/db-contexts', {
      baseURL: MEAL_PLANNER_API_URL,
    })
    .then((res) => res.data)
}

export const dbContextsQuery = queryOptions({
  queryKey: ['dbContexts'],
  queryFn: () => fetchDBContexts(),
})

export async function fetchAdminsAndAmbassadors() {
  return apiClient.get<User[]>('/account/authors').then((res) => res.data)
}

export const adminsAndAmbassadorsQuery = queryOptions({
  queryKey: ['authors'],
  queryFn: () => fetchAdminsAndAmbassadors(),
})
